<wim-assignment [assignments]="qualificationAssignments"
                [title]="'INSPECTIONS.INSPECTIONS' | translate"
                (updatedAssignment)="updateAssignment($event)">
</wim-assignment>
